import { render, staticRenderFns } from "./ConsultNote.vue?vue&type=template&id=8fc48e1e&scoped=true"
import script from "./ConsultNote.vue?vue&type=script&lang=js"
export * from "./ConsultNote.vue?vue&type=script&lang=js"
import style0 from "./ConsultNote.vue?vue&type=style&index=0&id=8fc48e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc48e1e",
  null
  
)

export default component.exports